module.exports = __webpack_public_path__ + "img/sword-zagreus.c95ceec2.jpg";